import { DetailItem, DetailItemProps } from "components";

const TransactionDetailItem = (props: DetailItemProps) => {
  const { _description, ...xprops } = props;
  return (
    <DetailItem
      borderBottomColor="transparent"
      _title={{ fontWeight: "600", color: "black" }}
      _description={{ fontSize: "sm", fontWeight: "500", color: "grey.400", ..._description }}
      {...xprops}
    />
  );
};

export default TransactionDetailItem;
